import { RefObject, useEffect, useState } from 'react';

interface Params {
  ref: RefObject<HTMLElement>;
  positionTop: number;
}

/**
 * position sticky를 사용하는 Dom의 stuck 여부를 감지하는 hook
 * @param ref sticky가 적용된 Dom의 ref
 * @param positionTop sticky가 적용된 Dom의 position top 위치
 * @returns isSticky sticky가 적용된 Dom이 stuck 상태인지 여부
 */
export default function useDetectSticky({ ref, positionTop }: Params) {
  const [isStuck, setIsStuck] = useState(false);

  useEffect(() => {
    if (ref.current) {
      const observer = new IntersectionObserver(
        ([{ intersectionRatio }]) => {
          setIsStuck(intersectionRatio > 0 && intersectionRatio < 1);
        },
        { rootMargin: `-${positionTop + 1}px 0px 0px 0px`, threshold: 1 },
      );

      observer.observe(ref.current);

      return () => observer.disconnect();
    }
  }, [ref, positionTop]);

  return { isStuck };
}
